// Constant trigger classes
var modal                = '.modal';
var modalOpen            = '.modal--open';
var modalOverlay         = '.modal__overlay';
var closeButton          = '.modal__close-button';
var openButton           = '.modal__trigger';
var navigationButton     = '#modal_productImage .modal__navigation';
var navigationPrevButton = '#modal_productImage .modal__navigation--prev';
var navigationNextButton = '#modal_productImage .modal__navigation--next';

var MODAL = {

    /**
     * [eventOpenModal - Opens up the modal, locks body from scrolling, and adds overlay]
     * @param {Event} e
     * @return void
     */
    open: function($modal) {
        // Open the Modal
        setTimeout(function(){
            $modal.addClass('modal--open');
            $('body').addClass('noscroll');

            // Broadcast a notification that a modal opened
            $(window).trigger('open.modal', $modal);
        }, 100);
    },

    swapImage: function($modal, $imageSrc) {
        $modal.find('.modal-content__image').attr('src', $imageSrc);
    },

    navigationCheck: function($currentThumb, $navigation) {
        switch($navigation) {
            case 'prev':
                if ($currentThumb.prev().length) {
                    return true;
                }
                return false;
            case 'next':
                if ($currentThumb.next().length) {
                    return true;
                }
                return false;

            default:
                return false;
        }
    },

    goToImage: function(event) {
        var target = $(event.currentTarget).data('target'),
            currentThumb = $(target).find('.css-grid__item--image-thumb.current'),
            navigation = $(event.currentTarget).data('navigation'),
            modal = $('#modal_' + $(event.currentTarget).data('modal'));
        if ($(event.currentTarget).hasClass('active')) {

            currentThumb.removeClass('current');
            switch(navigation) {
                case 'prev':
                    var targetImage = currentThumb.prev().data('image-src');
                    currentThumb.prev().addClass('current');
                    break;
                case 'next':
                    var targetImage = currentThumb.next().data('image-src');
                    currentThumb.next().addClass('current');
                    break;
                default:
                    break;
            }

            var newCurrentThumb = $(target).find('.css-grid__item--image-thumb.current');

            if (this.navigationCheck(newCurrentThumb, 'prev') == true) {
                $(navigationPrevButton).addClass('active');
            } else {
                $(navigationPrevButton).removeClass('active');
            }
            
            if (this.navigationCheck(newCurrentThumb, 'next') == true) {
                $(navigationNextButton).addClass('active');
            } else {
                $(navigationNextButton).removeClass('active');
            }

            this.swapImage(modal, targetImage);
        }
    },

    handleTouchStart: function _handleTouchStart(event) {
      this.touchStart = event.originalEvent.changedTouches[0];
    },

    handleTouchEnd: function _handleTouchEnd(event) {
        if (!this.touchStart) {
            return;
        } // touch points


        var touchStart = this.touchStart;
        var touchEnd = event.originalEvent.changedTouches[0]; // touch stroke differentials

        var dX = touchStart.clientX - touchEnd.clientX;
        var dY = Math.abs(touchStart.clientY - touchEnd.clientY); // sensitivities

        if (dX > 0) {
            $(navigationNextButton).trigger('click');
        } else {
            $(navigationPrevButton).trigger('click');
        }

        this.touchStart = null;
    },

    goLeft: function(event) {
        var target = $(event.currentTarget).data('target'),
            currentThumb = $(target).find('.css-grid__item--image-thumb.current'),
            navigation = $(event.currentTarget).data('navigation'),
            modal = $('#modal_' + $(event.currentTarget).data('modal'));
        if ($(event.currentTarget).hasClass('active')) {

            currentThumb.removeClass('current');
            var targetImage = currentThumb.prev().data('image-src');
            currentThumb.prev().addClass('current');    

            var newCurrentThumb = $(target).find('.css-grid__item--image-thumb.current');

            if (this.navigationCheck(newCurrentThumb, 'prev') == true) {
                $(navigationPrevButton).addClass('active');
            } else {
                $(navigationPrevButton).removeClass('active');
            }
            
            if (this.navigationCheck(newCurrentThumb, 'next') == true) {
                $(navigationNextButton).addClass('active');
            } else {
                $(navigationNextButton).removeClass('active');
            }

            this.swapImage(modal, targetImage);
        }
    },

    goRight: function(event) {
        var target = $(event.currentTarget).data('target'),
            currentThumb = $(target).find('.css-grid__item--image-thumb.current'),
            navigation = $(event.currentTarget).data('navigation'),
            modal = $('#modal_' + $(event.currentTarget).data('modal'));
        if ($(event.currentTarget).hasClass('active')) {

            currentThumb.removeClass('current');
            var targetImage = currentThumb.next().data('image-src');
            currentThumb.next().addClass('current');

            var newCurrentThumb = $(target).find('.css-grid__item--image-thumb.current');

            if (this.navigationCheck(newCurrentThumb, 'prev') == true) {
                $(navigationPrevButton).addClass('active');
            } else {
                $(navigationPrevButton).removeClass('active');
            }
            
            if (this.navigationCheck(newCurrentThumb, 'next') == true) {
                $(navigationNextButton).addClass('active');
            } else {
                $(navigationNextButton).removeClass('active');
            }

            this.swapImage(modal, targetImage);
        }
    },

    /**
     * [eventCloseModal - Closes up the modal, un-position:fix's body, and removes overlay]
     * @param {Event} e
     * @return void
     */
    close: function() {


        // Determine which modal(s) are open
        var $openModals = $(modalOpen);

        // Close all modals
        $openModals.removeClass('modal--open');
        $openModals.removeClass('running');
        $('body').removeClass('noscroll');

        // Broadcast a notification that a modal closed
        $.each($openModals, function(index, openModal) {
            $(window).trigger('close.modal', openModal);
        });
    },


    /**
     * [eventOpenModal - Opens up the modal, locks body from scrolling, and adds overlay]
     * @param {Event} e
     * @return void
     */
    clickTrigger: function(event) {
        event.preventDefault();
        // Get the modal associated with the target
        var modal = $('#modal_' + $(event.currentTarget).data('modal-target')),
            currentThumb = $(event.currentTarget),
            targetImage = $(event.currentTarget).data('image-src');
        $(currentThumb).siblings().removeClass('current');
        $(currentThumb).addClass('current');
        if (currentThumb.prev().length) {
            $(navigationPrevButton).addClass('active');
        } else {
            $(navigationPrevButton).removeClass('active');
        }

        if (currentThumb.next().length) {
            $(navigationNextButton).addClass('active');
        } else {
            $(navigationNextButton).removeClass('active');
        }

        this.swapImage(modal, targetImage);
        this.open(modal);
    }
};


/**
 * Bind Modal Triggers
 */
$(document).ready(function() {

    $(document).on('click', openButton,             _.bind(MODAL.clickTrigger, MODAL));
    $(document).on('click', navigationButton,       _.bind(MODAL.goToImage, MODAL));
    $(document).on('touchstart', '#modal_productImage .modal__content',   _.bind(MODAL.handleTouchStart, MODAL));
    $(document).on('touchend', '#modal_productImage .modal__content',   _.bind(MODAL.handleTouchEnd, MODAL));
    $(document).on('click', closeButton,            _.bind(MODAL.close));
    $(document).on('click', modalOverlay,           _.bind(MODAL.close));
    $(document).on('keydown', function(e) {
        if (e.keyCode === 27) { // Esc key
            MODAL.close();
        }
    });
})